import React from 'react';
import Img from 'react-image';

import { FlexBox, Typography, Box, Card, color } from '@kis-technologies/kis-ui';
import NoImagePreview from 'assets/no_image_preview.png';

interface ImagePreviewProps {
  previewUrl: string;
  activeImage: string | null;
  imageType?: string;
}
export const ImagePreview: React.FC<ImagePreviewProps> = (props: ImagePreviewProps) => {
  const { previewUrl, activeImage, imageType } = props;

  return (
    <Box margin="0 3" width={325}>
      <Card raised hasBorderRadius>
        <Card.Title
          title={
            <Typography fontSize={18} fontWeight={600}>
              Image Preview
            </Typography>
          }
          gutter={5}
        />
        <Card.Content>
          <FlexBox padding="2" align="center" justify="center">
            {['event', 'genre', 'venue'].includes(imageType || '') ? (
              <FlexBox width={200} height={150} align="center" justify="center">
                <Img
                  src={previewUrl}
                  width="100%"
                  height="100%"
                  unloader={
                    <img
                      src={NoImagePreview}
                      alt="Loading"
                      width={180}
                      height={158}
                      style={{ objectFit: 'scale-down' }}
                    />
                  }
                  style={{ objectFit: 'cover' }}
                />
              </FlexBox>
            ) : (
              <FlexBox width={230} height={252} align="center" justify="center">
                <Img
                  src={previewUrl}
                  width="100%"
                  height="100%"
                  unloader={
                    <img
                      src={NoImagePreview}
                      alt="Loading"
                      width={180}
                      height={158}
                      style={{ objectFit: 'scale-down' }}
                    />
                  }
                  style={{ objectFit: 'scale-down' }}
                />
              </FlexBox>
            )}
          </FlexBox>
        </Card.Content>
        {activeImage ? (
          <Card.Content gutter={5}>
            <FlexBox fullWidth style={{ borderTop: `1px solid ${color.X_LIGHT_GRAY}` }}>
              <Box width={225}>
                <Typography fontSize={18}>File Details</Typography>
                <Typography>Name: {activeImage}</Typography>
              </Box>
            </FlexBox>
          </Card.Content>
        ) : null}
      </Card>
    </Box>
  );
};
